<div class="row justify-content-center">
  <div class="input-group mb-3">
    <select class="form-select" required [(ngModel)]="year" [ngModelOptions]="{standalone: true}"name="year">
      <option value="" disabled selected>Please select a report year</option>
      <!-- <option [value]="2021">2021</option>-->
      <option [value]="2022">2022</option>
      <option [value]="2023">2023</option>
      <option [value]="2024">2024</option>
      <option [value]="2025">2025</option>
      <option [value]="2026">2026</option>
      <option [value]="2027">2027</option>
      <option [value]="2028">2028</option>
    </select>

    <div class="invalid-feedback">
      A report year is required
    </div>
  </div>
</div>
<div class="row justify-content-center">
  <div class="col-md-9 text-center">
    <form class="d-inline-block">
      <input type="text" class="form-control" name="keyword" [(ngModel)]="keyword" (ngModelChange)="search()" placeholder="Search">
    </form>
  </div>
  <div class="col-md-3">
    <button type="button" (click)="newItem()"  class="btn btn-primary btn-block">Add</button>
  </div>

</div>
<div class="row justify-content-center">
  <div class="col-md-9 text-center">
    <div class="table-responsive">
    <table class="table table-borderless text-start mt-4 table-hover">
      <thead>
    <tr>
      <th>Short Name</th>
      <th>Name</th>
      <th>Type</th>
      <th></th>
      <th></th>
    </tr>
      </thead>
      <tbody>
    <tr *ngFor="let template of results.content">
      <td (click)="open(template)">{{template.shortName}}</td>
      <td (click)="open(template)">{{template.name}}</td>
      <td (click)="open(template)">{{template?.higherEducationInstitutionType.name }}</td>
      <td><button (click)="download(template, year)" class="btn btn-primary">Download</button> </td>
      <td><i class="fa fa-close" (click)="remove(template)">  </i></td>
    </tr>
      </tbody>
      <tfoot *ngIf="results.totalElements > 0">
    <td>
      <div class="dataTables_info" id="dynamic-table_info" role="status" aria-live="polite">Showing {{((currentPage-1)*perPage)+1}} to {{results.numberOfElements*currentPage}} of
        {{results.totalElements}} entries
      </div>
    </td>
    <td class="text-right">

      <ngb-pagination [collectionSize]="results.totalElements"
                      [pageSize]="perPage"
                      [(page)]="currentPage"
                      [maxSize]="10"
                      [rotate]="true"
                      (pageChange)="search()"></ngb-pagination>
    </td>
    </tfoot>
  </table>
</div>
  </div>
</div>
